import React, { useState, useEffect } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { Backdrop,CircularProgress,TextField,Card,Typography,Grid,Box,FormControl,FormLabel,FormControlLabel,Select,MenuItem,InputLabel,RadioGroup,Radio,Button,useMediaQuery,useTheme,Paper } from '@mui/material';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import axios from 'axios';
import moment from 'moment';
import { UploadOutlined } from '@ant-design/icons';
import { Button as AntButton, message, Upload,Image  } from 'antd';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function FieldPartner() {
	const [open, setOpen] = useState(false);
	const [InputData, setInputData] = useState({ mechanicName: '', dob: '', address: '', status: '', role: '', RegistrationStatus: 'Registered' });
	const navigate = useNavigate();
	const location = useLocation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const MobileNo = location.state?.MobileNo || '';
	const Edit = location.state?.Edit || '';
	const USER_NAME = localStorage.getItem("USER_NAME");
	const USER_ID = localStorage.getItem("USER_ID");

	const [UploadIDProof, setUploadIDProof] = useState([]);
	const [UploadPhoto, setUploadPhoto] = useState([]);
	
	const IDProofImg = {
        onRemove: (file) => {
            setUploadIDProof([]);
            const index = UploadIDProof.indexOf(file);
            const newFileList = UploadIDProof.slice();
            newFileList.splice(index, 1);
            setUploadIDProof(newFileList);
        },
        beforeUpload: (file) => {
            setUploadIDProof([]);
            const index = UploadIDProof.indexOf(file);
            const newFileList = UploadIDProof.slice();
            newFileList.splice(index, 1);
            setUploadIDProof(newFileList);

            setUploadIDProof([file]);
            message.success(`file uploaded successfully`)
            return false;
        },
        UploadIDProof,
    };
	
	const PhotoImg = {
        onRemove: (file) => {
            setUploadPhoto([]);
            const index = UploadPhoto.indexOf(file);
            const newFileList = UploadPhoto.slice();
            newFileList.splice(index, 1);
            setUploadPhoto(newFileList);
        },
        beforeUpload: (file) => {
            setUploadPhoto([]);
            const index = UploadPhoto.indexOf(file);
            const newFileList = UploadPhoto.slice();
            newFileList.splice(index, 1);
            setUploadPhoto(newFileList);

            setUploadPhoto([file]);
            message.success(`file uploaded successfully`)
            return false;
        },
        UploadPhoto,
    };


	useEffect(() => {
		if(Edit === 1){
			loadMechanicDetails();
		}
	}, []);

	const loadMechanicDetails = () => {
		setOpen(true);
		const data = { type: 'FieldPartnerEditDataLoad', USER_ID: USER_ID, MobileNo: MobileNo }
		axios.post(BASE_URL + '/FieldPartner', data)
		.then(response => {
			const userDetails = response.data.message;
			setInputData(prev => ({
				...prev,
				mechanicName: userDetails.Name,
				// dob: userDetails.DOB,
				dob:  moment(userDetails.dob).format('YYYY-MM-DD'),
				address: userDetails.Address,
				status: userDetails.Status,
				role: userDetails.Nature,
			}));
			
		}).catch(error => {
			Swal.fire({
				icon: "warning",
				text: `${error.response.data.message}`
			});
		}).finally(() => {
			setOpen(false);
		});
	};

	const handleInputChange = (e) => {
		setInputData({ ...InputData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async () => {
		setOpen(true);
		
		if (!InputData.mechanicName) {
            Swal.fire({
                icon: "info",
                text: 'Enter The Mechanic Name.!'
            });
			setOpen(false);
			return false;
        } else if (!InputData.dob) {
            Swal.fire({
                icon: "info",
                text: 'Enter The Date of Birth.!'
            });
			setOpen(false);
			return false;
        } else if (!InputData.address) {
            Swal.fire({
                icon: "info",
                text: 'Enter The Address.!'
            });
			setOpen(false);
			return false;
        } else if (!InputData.role) {
            Swal.fire({
                icon: "info",
                text: 'Select The Role.!'
            });
			setOpen(false);
			return false;
        }
		
		const formData = new FormData();
		UploadIDProof.forEach((file) => {
			formData.append('IDProofImg', file);
		});
		UploadPhoto.forEach((file) => {
			formData.append('PhotoImg', file);
		});
		formData.append('MobileNo', MobileNo);
		formData.append('MechanicName', InputData.mechanicName);
		formData.append('DOB', InputData.dob);
		formData.append('Address', InputData.address);
		formData.append('Status', InputData.status);
		formData.append('Role', InputData.role);
		formData.append('RegistrationStatus', InputData.RegistrationStatus);
		formData.append('USER_NAME', USER_NAME);
		formData.append('USER_ID', USER_ID);
		formData.append('type', "FieldPartnerInsert");
		
        axios.post(BASE_URL + '/FieldPartner', formData).then(response => {
			Swal.fire({
				icon: "success",
				text: response.data.message
			});
			navigate(-1);
		}).catch(error => {
			Swal.fire({
				icon: "warning",
				text: error.response.data.message
			});
		}).finally(()=>{
			setOpen(false);
		})
	};

	const handleUpdate = () => {
		alert(1);
	};
	
	
	return (
		<>
			<Backdrop sx={{ color: '#fff', zIndex: theme.zIndex.drawer + 1 }} open={open}>
				<CircularProgress color="inherit" />
			</Backdrop>

			<Box sx={{ p: isMobile ? 2 : 4 }}>
				<Paper elevation={3} sx={{ p: 3 }}>
					<Typography variant="h6" align="center" gutterBottom>
					{Edit === 1 ? (
						<>Field Partner Update</>
					):(
						<>Field Partner Registration</>
					)}
					<hr/>
					</Typography>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={4}>
							<TextField
								label="Mobile Number"
								variant="outlined"
								size="small"
								fullWidth
								value={MobileNo}
								disabled
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							<TextField
								label="Mechanic Name"
								name="mechanicName"
								variant="outlined"
								size="small"
								fullWidth
								value={InputData.mechanicName}
								onChange={handleInputChange}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							<TextField
								label="Date Of Birth"
								name="dob"
								type="date"
								variant="outlined"
								size="small"
								fullWidth
								InputLabelProps={{ shrink: true }}
								value={InputData.dob}
								onChange={handleInputChange}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								label="Address"
								name="address"
								multiline
								rows={2}
								variant="outlined"
								size="small"
								fullWidth
								value={InputData.address}
								onChange={handleInputChange}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<center>
								<Upload {...IDProofImg}>
									<AntButton icon={<UploadOutlined />}>Click to Upload ID Proof</AntButton>
								</Upload>
							</center>
							{/* <Image width={100} src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" /> */}
							<hr/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<center>
								<Upload {...PhotoImg}>
									<AntButton icon={<UploadOutlined />}>Click to Upload Photo</AntButton>
								</Upload>
							</center>
							{/* <Image width={100} src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" /> */}
							<hr/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl fullWidth size="small">
								<InputLabel>Status</InputLabel>
								<Select
									name="status"
									value={InputData.status}
									label="Status"
									onChange={handleInputChange}
								>
									<MenuItem value="Active">Active</MenuItem>
									<MenuItem value="Inactive">Inactive</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl component="fieldset" fullWidth>
								<FormLabel>Select Role</FormLabel>
								<RadioGroup
									row={!isMobile}
									name="role"
									value={InputData.role}
									onChange={handleInputChange}
								>
									<FormControlLabel value="Field Mechanic" control={<Radio />} label="Field Mechanic" />
									<FormControlLabel value="Water Diviner" control={<Radio />} label="Water Diviner" />
									<FormControlLabel value="Borewell Operator" control={<Radio />} label="Borewell Operator" />
									<FormControlLabel value="Installer" control={<Radio />} label="Installer" />
								</RadioGroup>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl fullWidth size="small" disabled>
								<InputLabel>Registration Status</InputLabel>
								<Select value={InputData.RegistrationStatus} label="Registration Status">
									<MenuItem value="Registered">Registered</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12}>
								<Button
									variant="contained"
									fullWidth
									startIcon={<AddCircleOutlineIcon />}
									onClick={handleSubmit}
								>
									{Edit === 1 ? (
										<b>Update</b>
									):(
										<b>Submit</b>
									)}
								</Button>
						</Grid>
					</Grid>
				</Paper>
			</Box>
		</>
	);
}
